module.exports = __webpack_public_path__ + "img/add-image.204240f2.svg";